var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.296,
    x2: 410.626,
    xlinkHref: "#lg1",
    y1: 129.855,
    y2: 291.948
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.224,
    x2: 278.89,
    xlinkHref: "#lg2",
    y1: 478.525,
    y2: -122.667
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.934,
    x2: 374.065,
    xlinkHref: "#lg1",
    y1: 110.532,
    y2: 227.664
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.696,
    x2: 312.696,
    xlinkHref: "#lg2",
    y1: 247.437,
    y2: 305.441
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.462,
    x2: 321.907,
    xlinkHref: "#lg1",
    y1: 82.896,
    y2: 234.607
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.816,
    x2: 257.481,
    xlinkHref: "#lg2",
    y1: 509.206,
    y2: -91.986
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.525,
    x2: 352.657,
    xlinkHref: "#lg1",
    y1: 141.214,
    y2: 258.345
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.287,
    x2: 291.287,
    xlinkHref: "#lg2",
    y1: 278.119,
    y2: 336.122
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.964,
    x2: 307.719,
    xlinkHref: "#lg1",
    y1: 45.249,
    y2: 474.924
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.407,
    x2: 236.072,
    xlinkHref: "#lg2",
    y1: 539.888,
    y2: -61.304
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.117,
    x2: 331.248,
    xlinkHref: "#lg1",
    y1: 171.895,
    y2: 289.026
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.878,
    x2: 269.878,
    xlinkHref: "#lg2",
    y1: 308.8,
    y2: 366.804
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.313,
    x2: 314.463,
    xlinkHref: "#lg2",
    y1: 418.48,
    y2: 319.012
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.002,
    x2: 296.285,
    y1: 175.541,
    y2: 554.905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#2bb9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7345,
    stopColor: "#42a0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.338,
    x2: 208.338,
    y1: 420.673,
    y2: 463.608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.208,
    x2: 240.721,
    y1: 216.169,
    y2: 336.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.806,
    x2: 69.147,
    y1: 384.963,
    y2: 412.632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.953,
    x2: 115.295,
    y1: 384.963,
    y2: 412.632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m492.063 282.367h-358.734c-9.906 0-17.937-8.031-17.937-17.937v-196.271c0-9.906 8.031-17.937 17.937-17.937h358.734c9.906 0 17.937 8.031 17.937 17.937v196.271c0 9.906-8.031 17.937-17.937 17.937z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.8 123.103v86.383c0 5.006 3.561 9.223 8.455 10.274 14.697 3.157 26.398 14.378 30.253 28.805 1.23 4.602 5.361 7.826 10.125 7.826h254.126c4.764 0 8.895-3.224 10.125-7.826 3.855-14.427 15.555-25.647 30.253-28.805 4.894-1.051 8.455-5.269 8.455-10.274v-86.383c0-5.006-3.561-9.223-8.455-10.274-14.697-3.157-26.398-14.378-30.253-28.805-1.23-4.602-5.361-7.826-10.125-7.826h-254.126c-4.764 0-8.895 3.224-10.125 7.826-3.855 14.427-15.555 25.647-30.253 28.805-4.894 1.051-8.455 5.268-8.455 10.274z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.696,
    cy: 166.294,
    fill: "url(#SVGID_3_)",
    r: 58.069
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.392 224.363v40.067c0 9.906 8.031 17.937 17.937 17.937h358.734c9.906 0 17.937-8.031 17.937-17.937v-40.067z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m470.654 313.048h-358.734c-9.906 0-17.937-8.031-17.937-17.937v-196.271c0-9.906 8.031-17.937 17.937-17.937h358.734c9.906 0 17.937 8.031 17.937 17.937v196.271c0 9.907-8.031 17.937-17.937 17.937z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.392 153.784v86.383c0 5.006 3.561 9.223 8.455 10.274 14.697 3.157 26.398 14.378 30.253 28.805 1.23 4.602 5.361 7.826 10.125 7.826h254.125c4.764 0 8.895-3.224 10.125-7.826 3.855-14.427 15.555-25.647 30.253-28.805 4.894-1.051 8.455-5.269 8.455-10.274v-86.383c0-5.006-3.561-9.223-8.455-10.274-14.697-3.157-26.398-14.378-30.253-28.805-1.23-4.602-5.361-7.826-10.125-7.826h-254.126c-4.764 0-8.895 3.224-10.125 7.826-3.855 14.427-15.555 25.647-30.253 28.805-4.894 1.051-8.454 5.269-8.454 10.274z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.287,
    cy: 196.976,
    fill: "url(#SVGID_7_)",
    r: 58.069
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.983 255.045v40.067c0 9.906 8.031 17.937 17.937 17.937h358.734c9.906 0 17.937-8.031 17.937-17.937v-40.067z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m449.245 343.73h-358.734c-9.906 0-17.937-8.031-17.937-17.937v-196.272c0-9.906 8.031-17.937 17.937-17.937h358.734c9.906 0 17.937 8.031 17.937 17.937v196.271c.001 9.907-8.03 17.938-17.937 17.938z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.983 184.465v86.383c0 5.006 3.561 9.223 8.455 10.274 14.697 3.157 26.398 14.378 30.253 28.805 1.23 4.602 5.361 7.826 10.125 7.826h254.126c4.764 0 8.895-3.224 10.125-7.826 3.855-14.427 15.555-25.647 30.253-28.805 4.894-1.051 8.455-5.269 8.455-10.274v-86.383c0-5.006-3.561-9.223-8.455-10.274-14.697-3.157-26.398-14.378-30.253-28.805-1.23-4.602-5.361-7.826-10.125-7.826h-254.127c-4.764 0-8.895 3.224-10.125 7.826-3.855 14.427-15.555 25.647-30.253 28.805-4.893 1.052-8.454 5.269-8.454 10.274z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.878,
    cy: 227.657,
    fill: "url(#SVGID_11_)",
    r: 58.069
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.574 285.726v40.067c0 9.906 8.031 17.937 17.937 17.937h358.734c9.906 0 17.937-8.031 17.937-17.937v-40.067z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m90.511 343.73h358.734c9.906 0 17.937-8.031 17.937-17.937v-12.744h3.471c9.907 0 17.937-8.031 17.937-17.937v-7.695l-80.014-80.014c-5.768-6.401-14.122-9.427-23.417-9.427h-312.585v127.817c0 9.906 8.031 17.937 17.937 17.937z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m385.161 459.779h-353.645c-17.406 0-31.516-14.111-31.516-31.517v-199.77c0-17.406 14.11-31.516 31.516-31.516h353.644c17.406 0 31.516 14.11 31.516 31.516v199.771c.001 17.405-14.109 31.516-31.515 31.516z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 399.161v29.102c0 17.406 14.11 31.516 31.516 31.516h353.644c17.406 0 31.516-14.11 31.516-31.516v-29.102z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 240.817h416.677v73.817h-416.677z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 61.678,
    cy: 399.161,
    fill: "url(#SVGID_17_)",
    r: 30.741
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.826,
    cy: 399.161,
    fill: "url(#SVGID_18_)",
    r: 30.741
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0469bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m379.978 391.621h-131.855c-3.182 0-5.762-2.58-5.762-5.762v-9.983c0-3.182 2.58-5.762 5.762-5.762h131.855c3.182 0 5.762 2.58 5.762 5.762v9.983c0 3.182-2.579 5.762-5.762 5.762z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.201 428.208h-70.078c-3.182 0-5.762-2.58-5.762-5.762v-9.983c0-3.182 2.58-5.762 5.762-5.762h70.078c3.182 0 5.762 2.58 5.762 5.762v9.983c0 3.182-2.58 5.762-5.762 5.762z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/icon-credit-card.f1dadee7b297865c6c93e907e9e0303e.svg";
export { ForwardRef as ReactComponent };